<template>
	<div class="flex flex_between">
		<md-field :class="[{ 'md-error': error }]">
			<label>{{ label }}</label>
			<TbSelect
				v-model="moduleValue"
				@md-selected="onSelect"
				:search-allow="true"
				:options="availableDebtors"
				options-value-field="id"
				options-display-field="displayValue"
				:disabled="disabled"
				required
			>
				<md-option v-if="allowAddDebtor" :value="addNewDebtorOptionValue" slot="after">
					<div class="flex flex_center">
						<i class="fa fa-pencil-square-o font_lg" aria-hidden="true" style="width: 20px;"></i>
						<span>{{ $t('seller.upload.availableDebtor.addNew') }}</span>
					</div>
				</md-option>
			</TbSelect>
			<span v-if="error" class="validation-error">{{ error }}</span>
		</md-field>
	</div>
</template>
<script>

import {navigationPaths} from "@/common/navigation/navigationPaths";

export default {
	props: {
		labelText: { type: String, default: "common.debtor" },
		api: { type: Function },
    callback: { type: Function },
		error: { type: Boolean, default: "" },
		value: { type: [Object, String], default: "" },
		disabled: { type: Boolean, default: false },
		allowAddDebtor: { type: Boolean, default: true }
	},
	data() {
		return {
			moduleValue: "",
			availableDebtors: [],
			availableDebtorsLoaded: false,
			addNewDebtorOptionValue: -1
		};
	},
	mounted() {
		this.loadAvailableDebtors();
	},
	methods: {
		loadAvailableDebtors() {
			this.api()
				.then(res => {
					this.availableDebtors = res.map(item => {
						return {
							...item,
							displayValue: this.getDisplayValue(item)
						};
					});

					this.availableDebtorsLoaded = true;
					this.changeOption();

          if (this.callback) {
            this.callback(res);
          }
				})
				.catch(this.toast);
		},
		onSelect() {
			if (this.moduleValue !== this.addNewDebtorOptionValue) {
				this.$emit("input", this.selectedDebtorData);
			} else {
				this.$emit("redirect");
				this.$router.push(navigationPaths.seller.debtors);
			}
		},
		changeOption() {
			if (!this.availableDebtorsLoaded) {
				return;
			}

			if (this.value) {
				this.moduleValue = this.value;
				if (!this.selectedDebtorData) {
					this.availableDebtors.push({
						...this.value,
						displayValue: this.moduleValue
					});
				}
			} else {
				this.moduleValue = "";
			}
		},
		getDisplayValue(data) {
			return data.name + " - " + data.city + (data.registrationNum ? "(" + data.registrationNum + ")" : "");
		},
	},
	computed: {
		selectedDebtorData() {
			return this.availableDebtors.find(option => option.id === this.moduleValue);
		},
    label() {
      return this.$t(this.labelText);
    }
	},
	watch: {
		value() {
			this.changeOption();
		}
	}
};
</script>